import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'zero-config', 'ZeroConfig', [["path",{"d":"M4 12a8 8 0 1 0 16 0a8 8 0 1 0 -16 0"}],["path",{"d":"M3 21l18 -18"}]]);